module.exports = __webpack_public_path__ + "static/media/leaf-cut-egg.66cad96a.png";